<script>
import Vue from 'vue';
import EmailLayout from '~/models/EmailLayout';
import ResourceSelect from '~/components/ResourceSelect/ResourceSelect.vue';

export default Vue.extend({
  extends: ResourceSelect,

  props: {
    getOptionLabel: {
      type: Function,
      required: false,
      default: (resource) => resource?.label,
    },

    query: {
      type: Object,
      required: false,
      default: () => new EmailLayout().append('template'),
    },
  },

  methods: {
    fetch() {
      return this.query.$all();
    },
  },
});
</script>
